import { motion, useReducedMotion, type Variants } from 'framer-motion';
import { ReactNode } from 'react';

/**
 * Subtle scroll-reveal wrapper.
 * - Fades + slides up 8px when 10% in view; runs once.
 * - Respects prefers-reduced-motion (instant opacity, no transform).
 * - `delay` (seconds) for cascade staggering.
 */
interface RevealProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'section' | 'li';
  y?: number;
}

const Reveal = ({ children, delay = 0, className, as = 'div', y = 8 }: RevealProps) => {
  const reduce = useReducedMotion();
  const variants: Variants = {
    hidden: { opacity: 0, y: reduce ? 0 : y },
    show: { opacity: 1, y: 0 },
  };
  const MotionTag = (motion as any)[as];
  return (
    <MotionTag
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: '-10% 0px' }}
      variants={variants}
      transition={{ duration: 0.4, ease: 'easeOut', delay }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
